import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import Temperley from './pages/Temperley';
import Glew from './pages/Glew';
import Cet from './pages/Cet';
import CD from './pages/CD';
import ObrasSociales from './pages/ObrasSociales';
import Tratamientos from './pages/Tratamientos';
import Actividades from './pages/Actividades';
import Contacto from './pages/Contacto';
import NotFound from './pages/NotFound';

function PrerenderSignal() {
  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.dispatchEvent(new Event('render-event'));
      });
    });
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/temperley" element={<Temperley />} />
          <Route path="/glew" element={<Glew />} />
          <Route path="/cet" element={<Cet />} />
          <Route path="/cd" element={<CD />} />
          <Route path="/obras-sociales" element={<ObrasSociales />} />
          <Route path="/tratamientos" element={<Tratamientos />} />
          <Route path="/actividades" element={<Actividades />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <PrerenderSignal />
      </main>
      <Footer />
    </Router>
  );
}

export default App;